export default __webpack_public_path__ + "static/media/icon_google_m.017932a2.svg";